const doc = [({"en":({"js":({"admin":({"roles":({"abilities":({"abilities_for":"Abilities for %{role}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;